import { Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Home from './components/Home'
import About from './components/About'
import Contact from './components/Contact'
import Layout from './components/Layout'
import Portfolio from './components/Portfolio'
// import Dashboard from './components/Dashboard'
import './App.scss'
import 'react-toastify/dist/ReactToastify.css'
import ErrorPage from './components/Error404/ErrorPage.jsx'
import SmartTvRemoteLegal from './components/SmartTvRemoteLegal'
import WeldingToolboxLegal from './components/WeldingToolboxLegal'

function App() {
  return (
    <>
      <ToastContainer position="top-right" />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        </Route>
        <Route
          path="/welding-toolbox-support"
          element={<WeldingToolboxLegal page="support" />}
        />
        <Route
          path="/welding-toolbox-privacy"
          element={<WeldingToolboxLegal page="privacy" />}
        />
        <Route
          path="/smart-tv-remote-support"
          element={<SmartTvRemoteLegal page="support" />}
        />
        <Route
          path="/smart-tv-remote-privacy"
          element={<SmartTvRemoteLegal page="privacy" />}
        />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  )
}

export default App
